import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { Typography } from '../node_modules/@material-ui/core';

const style = {
    formInput: {
        marginTop: '30px',
        height: '50px',
        width: '90%',
        verticalAlign: 'middle',
        display: 'inline-block'
    },
    formContainer: {
        padding: '12px'
    },
    formButton: {
        padding: '10px',
        margin: '10px'
    }
};

class SignatureForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleChange = this.handleChange.bind(this);
        this.submitSignature = this.submitSignature.bind(this);
    }

    submitSignature(event) {
        console.log(this.state);
        if (this.props.updateSignature) {
            this.props.updateSignature(this.state);
        }
        if (event) {
            event.preventDefault();
        }
    }

    handleChange(event) {
        let state = Object.assign({}, this.state);
        const key = event.target.name;
        if (key.length > 0) {
            state[key] = event.target.value;
        } else {
            delete state[key];
        }
        this.setState(state);
    }

    checkButtonEnabled() {
        const items = Object.values(this.state);
        const length = items.reduce((acc, item) => acc + item.length, 0);
        return length !== 0;
    }

    render() {
        const { classes } = this.props;
        const enabled = this.checkButtonEnabled();
        return (
            <form className={classes.formContainer}>
                <Typography>{'Enter YOUR info:'.toUpperCase()}</Typography>
                <div>
                    <Input
                        name="name"
                        className={classes.formInput}
                        type="text"
                        value={this.state.username}
                        placeholder="Name"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <Input
                        name="surname"
                        className={classes.formInput}
                        type="text"
                        value={this.state.usersurname}
                        placeholder="Surname"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <Input
                        name="job"
                        className={classes.formInput}
                        type="text"
                        value={this.state.userjob}
                        placeholder="Job description"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <Input
                        name="email"
                        className={classes.formInput}
                        type="text"
                        value={this.state.useremail}
                        placeholder="e-mail"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <Input
                        name="mobile"
                        className={classes.formInput}
                        type="text"
                        value={this.state.usermobile}
                        placeholder="mobile"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <Input
                        name="linkedin"
                        className={classes.formInput}
                        type="text"                        
                        value={this.state.userlinkedin}
                        placeholder="LinkedIn Page"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <Input
                        name="website"
                        className={classes.formInput}
                        type="text"
                        value={this.state.userwebsite}
                        placeholder="neosperience.com"
                        onChange={this.handleChange}
                    />
                </div>

                <div className={classes.formButton}>
                    <Button
                        disabled={!enabled}
                        variant="contained"
                        color="primary"
                        onClick={this.submitSignature}
                    >
                        Generate Signature
                    </Button>
                </div>
            </form>
        );
    }
}
export default withStyles(style)(SignatureForm);



// WEBPACK FOOTER //
// ./src/SignatureForm.js